module.exports = __webpack_public_path__ + "static/media/success_tick_pink.3747155d.svg";